// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__2MN5T","withMobileMargins":"DateRangeInput_withMobileMargins__-Ht2T","arrowIcon":"DateRangeInput_arrowIcon__3C2b0"};